{
  "en": {
    "curriculum": {
      "confirmDelete": {
        "confirm": "Yes, delete",
        "text": "Do you really want to delete \"{filename}\"? The file and its searchable curriculum content will be removed.",
        "title": "Delete curriculum?"
      },
      "confirmedUseful": "Curriculum was confirmed for search.",
      "confirmUseful": "Use for curriculum search",
      "confirmUsefulFailed": "Curriculum could not be confirmed.",
      "configure": "Open curriculum settings",
      "delete": "Delete curriculum",
      "deleted": "Curriculum was deleted.",
      "deleteFailed": "Curriculum could not be deleted.",
      "empty": "No personal curriculum documents have been uploaded yet.",
      "documentKindDescriptions": {
        "cross_curricular_framework": "A cross-curricular framework, for example for media education or digital competencies.",
        "curriculum_guidance": "A guide, commentary, or support material for working with a curriculum.",
        "general_curriculum_part": "A general curriculum part without one specific subject, for example principles or cross-cutting goals.",
        "non_curriculum": "This file was detected as not being a curriculum document.",
        "presentation_or_training_material": "Presentation or training material about curricula, but not the actual curriculum.",
        "subject_curriculum": "A subject-specific curriculum or subject requirements for one concrete school subject.",
        "unknown": "The document type could not be detected reliably."
      },
      "documentKindLabels": {
        "cross_curricular_framework": "Framework",
        "curriculum_guidance": "Guidance",
        "general_curriculum_part": "General curriculum part",
        "non_curriculum": "Not a curriculum",
        "presentation_or_training_material": "Presentation / training",
        "subject_curriculum": "Subject curriculum",
        "unknown": "Unclear"
      },
      "fields": {
        "country": "Country",
        "documentKind": "Document type",
        "gradeLevel": "Grade level",
        "region": "Region",
        "schoolType": "School type",
        "subject": "Subject",
        "title": "Title"
      },
      "hints": {
        "customCategoryValue": "Not found? Enter your own value."
      },
      "loading": "Loading curricula...",
      "needsReview": "We could not clearly assign this document to a curriculum, subject, grade level, or school type. It is probably only partially useful for curriculum search. Please complete the metadata or delete the file.",
      "notSet": "Not set",
      "officialAvailable": "Official curriculum data is available for these countries or regions: {locations}. Personal uploads can add missing or custom excerpts.",
      "officialMissing": "No official curriculum data is available for your selection yet. You can upload your own curriculum documents.",
      "placeholders": {
        "selectOrAddOptions": "Search, select, or enter your own value"
      },
      "saved": "Curriculum metadata saved.",
      "states": {
        "classification_failed": "Automatic classification failed",
        "classifying": "Curriculum is being analyzed",
        "file_processing_failed": "File could not be read",
        "import_failed": "Import failed",
        "indexing": "Being added to curriculum search",
        "needs_review": "Review needed",
        "official": "Official curriculum",
        "processing_file": "File is being processed",
        "searchable": "Searchable"
      },
      "statusDescriptions": {
        "classification_failed": "Automatic classification could not reliably detect subject, grade level, or school type. You can edit the metadata manually.",
        "classifying": "The curriculum text is being analyzed so subject, grade level, and school type can be suggested.",
        "file_processing_failed": "The file could not be read. Please upload a different PDF, DOCX, or text file.",
        "import_failed": "The curriculum could not be added to curriculum search. You can review the metadata and save it again.",
        "indexing": "The file was classified and is being prepared for curriculum search.",
        "needs_review": "The file was processed, but the curriculum metadata is unclear or incomplete.",
        "official": "Official curriculum data is available for this area.",
        "processing_file": "The file is being read and its text is being extracted.",
        "searchable": "The curriculum is indexed and can be used by curriculum search."
      },
      "title": "Curricula",
      "upload": "Upload curriculum",
      "uploaded": "Curriculum was uploaded and is being processed.",
      "uploadFailed": "Curriculum could not be uploaded."
    }
  }
}
